
  (function moveSalepifyEmbedWidget() {
    try {
      function relocateWidget() {
        try {
          const targetBlock = document.querySelector('.product-info__block-item .v-stack.gap-4') 
                           || document.querySelector('.product-info__block-item .v-stack');
          
          const embedWidget = document.querySelector('.salepify-embed-widget__embedded-list-container')
                           || document.querySelector('.salepify-embed-widget-container')
                           || document.querySelector('.salepify-embed-widget-placement');

          if (targetBlock && embedWidget) {
            if (embedWidget.previousElementSibling !== targetBlock) {
              targetBlock.insertAdjacentElement('afterend', embedWidget);
            }
            return true;
          }
        } catch (err) {
          console.warn('Salepify Embed Relocate Error:', err);
        }
        return false;
      }

      if (!relocateWidget()) {
        const observer = new MutationObserver(function() {
          try {
            if (relocateWidget()) {
              observer.disconnect();
            }
          } catch (err) {
            observer.disconnect();
          }
        });

        if (document.body) {
          observer.observe(document.body, { childList: true, subtree: true });
        } else {
          document.addEventListener('DOMContentLoaded', function() {
            try {
              observer.observe(document.body, { childList: true, subtree: true });
            } catch (err) {}
          });
        }

        setTimeout(function() { 
          try { observer.disconnect(); } catch (e) {} 
        }, 5000);
      }
    } catch (e) {
      console.warn('Salepify Script Execution Error:', e);
    }
  })();
